import { fuseProvisioningEventsService } from "../../_services";
import { fuseProvisioningEventsConstants } from "../_redux-constants";

function getFuseProvisioningEvents(queryParams) {
  function getFuseProvisioningEventsLoad() {
    return {
      type: fuseProvisioningEventsConstants.FUSE_PROVISIONING_EVENTS_LOADING,
    };
  }
  function FuseProvisioningEventsSuccess(data) {
    return {
      type: fuseProvisioningEventsConstants.FUSE_PROVISIONING_EVENTS_SUCCESS,
      data,
    };
  }
  function FuseProvisioningEventsFailure(error) {
    return {
      type: fuseProvisioningEventsConstants.FUSE_PROVISIONING_EVENTS_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getFuseProvisioningEventsLoad());
    fuseProvisioningEventsService.getFuseProvisioningEvents(queryParams).then(
      (data) => {
        dispatch(FuseProvisioningEventsSuccess(data));
      },
      (error) => {
        dispatch(FuseProvisioningEventsFailure(error?.toString()));
      }
    );
  };
}

export const fuseProvisioningEventsActions = {
  getFuseProvisioningEvents,
};
